export default __webpack_public_path__ + "static/media/welcome-3.84e744c6.png";